import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaBorderRadius, YodaColors, YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

export const OverlayStyle: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10,
};

export const ReorderingLoaderStyle: SxProps<Theme> = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export const TacticKanbanStyle = (isEmpty: boolean): SxProps<Theme> => ({
  marginTop: YodaSpacing.medium,
  paddingBottom: YodaSpacing.medium,
  display: 'flex',
  flexDirection: 'column',
  gap: YodaSpacing.small,
  height: isEmpty ? '100px' : 'auto',

  '& > *': {
    minWidth: '260px',
  },
});

export const StepCardWrapperStyle: (isDraggingOver: boolean) => SxProps<Theme> = (isDraggingOver) => ({
  padding: YodaSpacing.medium,
  border: 'none',
  boxShadow: `0px 5px 20px ${YodaColors.gray2}`,
  borderRadius: YodaBorderRadius.medium,
  backgroundColor: isDraggingOver ? YodaColors.blue2 : YodaColors.white,
  margin: YodaSpacing.small,
});

export const StepHeaderStyle: (isEditingDisabled: boolean) => SxProps<Theme> = (isEditingDisabled) => ({
  marginBottom: YodaSpacing.small,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: isEditingDisabled ? 'default' : 'grab',
});

export const TacticCardListStyle: SxProps<Theme> = {
  '& > *': {
    border: `1px solid ${YodaColors.gray7}`,
    borderRadius: YodaBorderRadius.small,
    marginBottom: YodaSpacing.small,
  },
  '& > *:last-child': {
    marginBottom: 0,
  },
  '& > *:hover': {
    backgroundColor: YodaColors.blue1,
    boxShadow: `0 0 7px 1px ${YodaColors.gray2}`,
  },

  '& > *:not([data-rbd-draggable-id])': {
    width: '100% !important',
    border: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    height: '0px',
  },
};

export const TacticKanbanButtonHeadStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: YodaJustifyContent.flexEnd,

  '& .MuiButton-root:first-of-type': {
    marginLeft: 'auto',
    marginRight: YodaSpacing.medium,
  },
};

export const TacticKanbanLoaderStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
};
